import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getGalleryImages } from "@/lib/api/content";

export default function FollowUs() {
  const { data: images = [], isLoading } = useQuery({
    queryKey: ["gallery", "home"],
    queryFn: () => getGalleryImages(),
    staleTime: 5 * 60 * 1000,
    select: (imgs) => imgs.slice(0, 6), // show first 6
  });

  return (
    <section className="pb-0 pt-16">
      {/* Header */}
      <div className="mb-10 text-center">
        <p className="eyebrow mb-3">Photos</p>
        <h2 className="mb-1 font-serif text-3xl text-metro-green-950 md:text-4xl">
          Gallery
        </h2>
        <p className="text-sm text-metro-ink-subtle">
          A glimpse of Hotel Metropolis
        </p>
      </div>

      {/* Image strip */}
      {isLoading ? (
        // Skeleton — 3 cols on mobile, 6 on md+
        <div className="grid grid-cols-3 md:grid-cols-6">
          {Array.from({ length: 6 }).map((_, i) => (
            <div
              key={i}
              className="aspect-square animate-pulse bg-metro-cream-100"
            />
          ))}
        </div>
      ) : images.length === 0 ? (
        <div className="flex h-48 items-center justify-center bg-metro-cream-100">
          <p className="text-sm text-metro-ink-subtle">
            No gallery images yet.{" "}
            <Link
              to="/gallery"
              className="font-medium text-metro-green-800 underline-offset-2 hover:underline"
            >
              Visit gallery →
            </Link>
          </p>
        </div>
      ) : (
        // 3 cols on mobile (2 rows of 3), 6 cols on md+ (1 row of 6)
        <div className="grid grid-cols-3 md:grid-cols-6">
          {images.map((img, idx) => (
            <Link
              key={img.id}
              to="/gallery"
              className="group relative aspect-square overflow-hidden"
              aria-label={img.caption || `Gallery photo ${idx + 1}`}
            >
              <img
                src={img.url}
                alt={img.caption || ""}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              {/* Overlay */}
              <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 bg-metro-green-950/55 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                {img.caption && (
                  <p className="px-3 text-center text-xs text-white/90 line-clamp-2">
                    {img.caption}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}